'use strict';
var app = require('angular').module('directive.pivotTable', []);


app.directive('pivotTable', [require('./pivotTableDirective')]);
